/**
 * PlayerBlock - Individual player on the canvas.
 *
 * Parent: PlayBlock, FormationBlock, or ConceptBlock
 * Children: none (leaf block)
 * Template source: block_references.player_template
 */

import type { BlockBase } from '../Base'
import type { PlayerProperties } from '@/types/BlockProperties'
import type { PlayBlock_Union } from '../Union'

/**
 * An individual player positioned on the canvas.
 * Has position, label, color, and role information.
 * Spatial properties (x, y, coordinateSystem) are stored in properties JSONB.
 */
export interface PlayerBlock extends BlockBase {
	type: 'player'
	properties: PlayerProperties
}

/**
 * Type guard for PlayerBlock.
 */
export function isPlayerBlock(block: PlayBlock_Union): block is PlayerBlock {
	return block.type === 'player'
}
